import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';

import esLocale from '@fullcalendar/core/locales/es';

import { StateService } from 'src/app/services/state.service';
import { DietService } from 'src/app/services/diet.service';

@Component({
  selector: 'app-diet-calendar',
  templateUrl: './diet-calendar.component.html',
  styleUrls: ['./diet-calendar.component.scss'],
})
export class DietCalendarComponent implements OnInit {
  @Input() routineGroupId!: number;
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;

  modalShow: 'calendar' | 'diet' = 'calendar';
  selectedDate?: string;

  calendarEvents: any;

  constructor(
    private stateService: StateService,
    private dietService: DietService
  ) {}

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay',
    },
    locale: esLocale,
    events: [],
    plugins: [dayGridPlugin],
    eventClick: this.handleEventClick.bind(this),
    dayCellDidMount: (info) => {
      const dayNumber = info.el.querySelector(
        '.fc-daygrid-day-number'
      ) as HTMLElement;
      if (dayNumber) {
        dayNumber.style.color = '#727578'; // Set the color of the day numbers to a brighter tone
      }
    },
    datesSet: (info) => {
      const dayHeaders = document.querySelectorAll(
        '.fc-col-header-cell-cushion'
      );
      dayHeaders.forEach((header) => {
        (header as HTMLElement).style.color = '#727578'; // Set the color of the day of the week to a brighter tone
      });
    },
  };

  ngOnInit(): void {
    this.setEventListener();
  }

  setEventListener() {
    const modalElement = document.getElementById('dietCalendarModal');
    modalElement!.addEventListener('shown.bs.modal', () => {
      this.getDietCalendar();
      this.renderCalendar();
    });

    modalElement!.addEventListener('hidden.bs.modal', () => {
      this.modalShow = 'calendar';
    });
  }

  renderCalendar() {
    setTimeout(() => {
      this.calendarComponent.getApi().render();
    }, 100);
  }

  handleEventClick(info: any) {
    if (!info.event.extendedProps.status.includes('NOT_TRACKED')) {
      this.selectedDate = info.event.startStr; // Set the selected date
      this.modalShow = 'diet';
      this.stateService.setModalShow(this.modalShow);
    }
    // You can add more logic here
  }

  handleBackButtonClick() {
    this.modalShow = 'calendar';

    this.getDietCalendar();
  }

  getDietCalendar() {
    const dietId = this.stateService.selectedDiet?.id;

    if (!dietId) return;

    this.dietService.getDietCalendar(dietId).subscribe((data: any) => {
      this.calendarEvents = data;
      if (!data) return;

      const events = data.map((item: any) => {
        let color = '#FED534'; // Default color
        let statusText = 'Estado desconocido'; // Default status text

        if (item.status.includes('OUT_OF_DIET')) {
          color = '#C35252';
          statusText = 'Fuera de dieta';
        } else if (item.status.includes('INCOMPLETE')) {
          color = '#BFC352';
          statusText = 'Incompleto';
        } else if (item.status.includes('NOT_TRACKED')) {
          color = '#C5C5C5';
          statusText = 'Sin datos';
        } else if (item.status.includes('COMPLETED')) {
          color = '#5FC353';
          statusText = 'Completo';
        }

        return {
          title: `${statusText}`, // Include status text in the title
          date: new Date(item.date).toISOString().split('T')[0], // Correctly parse the date
          color: color, // Set the color of the event based on status
          textColor: 'black', // Set the text color of the event to black
          extendedProps: {
            status: item.status, // Add workoutId to the event
          },
        };
      });

      events.push({
        title: 'Inicio de dieta',
        date: new Date(this.stateService.selectedDiet!.startedAt)
          .toISOString()
          .split('T')[0], // Correctly parse the date
        color: '#FED534',
        textColor: 'black',
      });

      events.push({
        title: 'Fin de dieta',
        date: new Date(this.stateService.selectedDiet!.finishedAt)
          .toISOString()
          .split('T')[0], // Correctly parse the date
        color: '#FED534',
        textColor: 'black',
      });

      this.calendarOptions.events = events;
      this.renderCalendar();

      // Move to the correct month to show the first event
      if (events.length > 0) {
        const firstEventDate = events[0].date;
        this.calendarComponent.getApi().gotoDate(firstEventDate);
      }
    });
  }
}
